export class Calc {
    public static TO_DEG: number = 180 / Math.PI;
    public static TO_RAD: number = Math.PI / 180;
    //365 day * 24 hours * 60 minutes * 60 seconds * 1000 milliseconds
    public static YEAR_MILLISECONDS: number = 31536000000;
    //24 hours * 60 minutes * 60 seconds * 1000 milliseconds
    public static DAY_MILLISECONDS: number = 86400000;

    public static clamp(value: number, min: number, max: number): number {
        if (min > max) {
            var tmp = max;
            max = min;
            min = tmp;
        }
        return (value < min) ? min : ((value > max) ? max : value);
    }

    public static ceilToPowerOfTwo(v: number): number {
        v--;
        v |= v >> 1;
        v |= v >> 2;
        v |= v >> 4;
        v |= v >> 8;
        v |= v >> 16;
        v++;
        return v;
    }

    public static randomBetweeen(min: number, max: number): number {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    public static precision(num: number, precesion: number): number {
        return Math.round(num * precesion) / precesion;
    }

    public static rangeContainsRange(valueStart: number, valueEnd: number, rangeStart: number, rangeEnd: number): boolean {
        if (valueStart <= rangeStart && valueEnd >= rangeEnd)
            return true;
        if (valueStart <= rangeStart && valueEnd >= rangeStart)
            return true;
        if (valueStart <= rangeEnd && valueEnd >= rangeEnd)
            return true;
        if (valueStart >= rangeStart && valueEnd <= rangeEnd)
            return true;
        return false;
    }

    public static ratio(value: number, start: number, end: number): number {
        var range = end - start;
        return (value - start) / range;
    }

    public static interpolate(ratio: number, start: number, end: number): number {
        return start + (end - start) * ratio;
    }

    public static isBetween(value: number, rangeStart: number, rangeEnd: number): boolean {
        return value >= rangeStart && value <= rangeEnd;
    }

    public static clampAvg(value: number, min: number, max: number, ratio: number = 0.5): number {
        if (min > max)
            return max + (min - max) * ratio;
        return (value < min) ? min : ((value > max) ? max : value);
    }

    public static clampFade(value: number, min: number, max: number, fade: number = 0.5): number {
        return (value < min) ? value + (min - value) * (1 - fade) : ((value > max) ? max + (value - max) * fade : value);
    }

    public static clampMin(value: number, min: number): number {
        return (value < min) ? min : value;
    }

    public static clampMax(value: number, max: number): number {
        return (value > max) ? max : value;
    }

    public static roundTo(value: number, mod: number): number {
        if (mod === 0)
            return value;
        return Math.round(value / mod) * mod;
    }

    public static floorTo(value: number, mod: number): number {
        return value - value % mod;
    }

    public static ceilTo(value: number, mod: number): number {
        if (mod === 0)
            return value;
        return value % mod === 0 ? value : value + (mod - (value % mod));
    }

    public static prec(value: number, c: number = 4): number {
        var countMant: number = Math.pow(10, c - 1);
        return Math.round(value * countMant) / countMant;
    }

    public static valueFromCss(value: string, referenceSize: number): number {
        return value.indexOf("%") > 0 ? (parseFloat(value.replace("%", "")) / 100) * referenceSize : parseFloat(value.replace("px", ""));
    }

    public static averageAngle(angles: number[]): number {
        var avgX: number = 0;
        var avgY: number = 0;
        var l: number = angles.length;
        if (l == 0)
            return 0;
        var ang = angles[0];
        for (var i: number = 1; i < l; ++i)
            ang += Calc.shortRotation(ang, angles[i]) * 0.5;
        return ang;
    }

    public static shortRotation(startRotation: number, endRotation: number): number {
        var dif: number = (endRotation - startRotation) % 360;
        if (dif != dif % 180)
            dif = (dif < 0) ? dif + 360 : dif - 360;
        return dif;
    }

    public static clampAngle(currentAngle: number, newAngle: number, minAngle: number, maxAngle: number): number {
        newAngle = Calc.clampMin(currentAngle + Calc.shortRotation(currentAngle, newAngle), minAngle);
        newAngle = Calc.clampMax(currentAngle + Calc.shortRotation(currentAngle, newAngle), maxAngle) % 360;
        if (newAngle < 0)
            newAngle += 360;
        return newAngle;
    }

    public static parse(value: any, defaultValue: number): number {
        value = parseFloat(value);
        if (isNaN(value)){
            return defaultValue;
        }
        return value;
    }

    public static wrap(index: number, length: number): number {
        if (length <= 1)
            return 0;
        var maxIndex = length - 1;
        if (index < 0)
            return maxIndex + ((index + 1) % length);
        else if (index > maxIndex)
            return index % length;
        return index;
    }

    public static relation(value: any, relativeSize: number, defaultValue: number): number {
        if (typeof value == "number") {
            return value;
        }
        else if (typeof value == "string") {
            value = (<string>value).trim().toLowerCase();

            //Float
            //@see https://stackoverflow.com/a/69946984/5221214
            if (/^[+-]?[0-9]+([.][0-9]+)?([eE][+-]?[0-9]+)?$/.test(value)) {
                return parseFloat(value);
            }
            else if (value.indexOf("%") > 0) {
                return (Calc.parse(value.replace("%", ""), defaultValue) / 100) * relativeSize;
            }
            else if (value.indexOf("px") > 0) {
                return Calc.parse(value.replace("px", ""), defaultValue);
            }
            else if (value.indexOf("pt") > 0) {
                return Calc.parse(value.replace("pt", ""), defaultValue);
            }
            else if (value.indexOf("vw") > 0) {
                return (Calc.parse(value.replace("vw", ""), defaultValue) / 100) * window.innerWidth;
            }
            else if (value.indexOf("vh") > 0) {
                return (Calc.parse(value.replace("vh", ""), defaultValue) / 100) * window.innerHeight;
            }
            else if (value.indexOf("vm") > 0) {
                return (Calc.parse(value.replace("vm", ""), defaultValue) / 100) * Math.min(window.innerWidth, window.innerHeight);
            }
            else if (value.indexOf("em") > 0) {
                return Calc.parse(value.replace("em", ""), defaultValue);
            }
            else if (value === "top" || value === "left" || value === "start") {
                return 0;
            }
            else if (value === "center" || value === "middle") {
                return relativeSize * 0.5;
            }
            else if (value === "bottom" || value === "right" || value === "end") {
                return relativeSize;
            }
            return defaultValue;
        }
        return defaultValue;
    }

    public static relationCalced(value: any, relativeSize: number, defaultValue: number): number {
        if (typeof value == "number") {
            return value;
        }

        if (typeof value == "string") {
            value = (<string>value).trim().toLowerCase();
            var vals: string[] = value.split(" ");
            var result = 0;
            var operation: "+" | "-" = "+"
            for (var i = 0; i < vals.length; ++i) {
                var val = vals[i].trim();

                if (i % 2 == 1) {
                    if (val == "+")
                        operation = "+";
                    else if (val == "-")
                        operation = "-";
                    continue;
                }

                var v = this.relation(val, relativeSize, defaultValue);
                if (operation == "+")
                    result += v;
                else if (operation == "-")
                    result -= v;
            }
            return result;
        }
        return defaultValue;
    }
}